const state = {
    isUserAuthenticated: false,
    auth: {
        user: null,
        token: null
    },
    isRefreshingToken: false,
    lastAuthTimestamp: null,
    logoutLoading: false,
    userLoaded: false,
};

export default state;
